import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SolutionsService } from './solutions.service';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-solutions',
  templateUrl: './solutions.component.html',
  styleUrls: ['./solutions.component.css']
})
export class SolutionsComponent implements OnInit, AfterViewInit {

  @ViewChild('emailLink') emailLink: ElementRef;

  activeTab = 'all';

  $solutionStore: Observable<any[]>;
  $solutions: Observable<any[]>;
  $groups: Observable<any[]>;
  selectedSolution?: any;
  public fragment;

  constructor(public solutionsService: SolutionsService, public route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.getSolutions();
    this.route.fragment.subscribe(fragment => {
      this.fragment = fragment;
      if (this.fragment) {
        this.filterSolutions(this.fragment);
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const elem = document.querySelector('#' + this.fragment);
      if (elem) {
        elem.scrollIntoView({ behavior: 'auto' });
      }
    }, 100);
  }

  sendEmail() {
    this.emailLink.nativeElement.setAttribute('href', 'mailto:courtstack@lacourt.org');
    this.emailLink.nativeElement.click();
    this.emailLink.nativeElement.remove();
  }

  filterSolutions(category?: string): void {
    this.activeTab = category;
    this.$solutions = this.$solutionStore.pipe(map(solutions => !category ? solutions : solutions.filter(s => s.category === category)));
    if (!category && this.fragment) {
      this.router.navigate([]);
    }
  }

  getSolutions() {
    this.$solutionStore = this.solutionsService.Solutions;
    this.$solutions = this.$solutionStore;
    this.$groups = this.$solutions.pipe(map(sols => [...new Set(sols.map(s => s.category))]));
  }

  selectSolution(solution: any) {
    this.selectedSolution = solution;
  }

}
